/* tslint:disable */
/* eslint-disable */
/**
 * DIV.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApplicationUser } from './ApplicationUser';
import {
    ApplicationUserFromJSON,
    ApplicationUserFromJSONTyped,
    ApplicationUserToJSON,
    ApplicationUserToJSONTyped,
} from './ApplicationUser';
import type { ClaimsIdentity } from './ClaimsIdentity';
import {
    ClaimsIdentityFromJSON,
    ClaimsIdentityFromJSONTyped,
    ClaimsIdentityToJSON,
    ClaimsIdentityToJSONTyped,
} from './ClaimsIdentity';
import type { IIdentity } from './IIdentity';
import {
    IIdentityFromJSON,
    IIdentityFromJSONTyped,
    IIdentityToJSON,
    IIdentityToJSONTyped,
} from './IIdentity';
import type { Claim } from './Claim';
import {
    ClaimFromJSON,
    ClaimFromJSONTyped,
    ClaimToJSON,
    ClaimToJSONTyped,
} from './Claim';

/**
 * 
 * @export
 * @interface Role
 */
export interface Role {
    /**
     * 
     * @type {Array<Claim>}
     * @memberof Role
     */
    readonly claims?: Array<Claim> | null;
    /**
     * 
     * @type {Array<ClaimsIdentity>}
     * @memberof Role
     */
    readonly identities?: Array<ClaimsIdentity> | null;
    /**
     * 
     * @type {IIdentity}
     * @memberof Role
     */
    identity?: IIdentity;
    /**
     * 
     * @type {string}
     * @memberof Role
     */
    id?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Role
     */
    isActive?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof Role
     */
    createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof Role
     */
    modifiedAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof Role
     */
    applicationUserId?: string;
    /**
     * 
     * @type {ApplicationUser}
     * @memberof Role
     */
    applicationUser?: ApplicationUser;
    /**
     * 
     * @type {string}
     * @memberof Role
     */
    readonly roleName?: string | null;
}

/**
 * Check if a given object implements the Role interface.
 */
export function instanceOfRole(value: object): value is Role {
    return true;
}

export function RoleFromJSON(json: any): Role {
    return RoleFromJSONTyped(json, false);
}

export function RoleFromJSONTyped(json: any, ignoreDiscriminator: boolean): Role {
    if (json == null) {
        return json;
    }
    return {
        
        'claims': json['claims'] == null ? undefined : ((json['claims'] as Array<any>).map(ClaimFromJSON)),
        'identities': json['identities'] == null ? undefined : ((json['identities'] as Array<any>).map(ClaimsIdentityFromJSON)),
        'identity': json['identity'] == null ? undefined : IIdentityFromJSON(json['identity']),
        'id': json['id'] == null ? undefined : json['id'],
        'isActive': json['isActive'] == null ? undefined : json['isActive'],
        'createdAt': json['createdAt'] == null ? undefined : (new Date(json['createdAt'])),
        'modifiedAt': json['modifiedAt'] == null ? undefined : (new Date(json['modifiedAt'])),
        'applicationUserId': json['applicationUserId'] == null ? undefined : json['applicationUserId'],
        'applicationUser': json['applicationUser'] == null ? undefined : ApplicationUserFromJSON(json['applicationUser']),
        'roleName': json['roleName'] == null ? undefined : json['roleName'],
    };
}

export function RoleToJSON(json: any): Role {
    return RoleToJSONTyped(json, false);
}

export function RoleToJSONTyped(value?: Omit<Role, 'claims'|'identities'|'roleName'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'identity': IIdentityToJSON(value['identity']),
        'id': value['id'],
        'isActive': value['isActive'],
        'createdAt': value['createdAt'] == null ? value['createdAt'] : value['createdAt'].toISOString(),
        'modifiedAt': value['modifiedAt'] == null ? value['modifiedAt'] : value['modifiedAt'].toISOString(),
        'applicationUserId': value['applicationUserId'],
        'applicationUser': ApplicationUserToJSON(value['applicationUser']),
    };
}

